










import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component
  export default class UiLogout extends Vue {
    @Prop()
    actionBeforeLogout: () => void;
    
    handleClick() {
      this.showConfirm();
    }

    showConfirm() {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
        confirmButtonText: this.t('Logout'),
        confirmButtonIcon: 'fas fa-sign-out-alt',
        message: this.t('Are you sure you want to logout?'),
        onConfirm: () => {
          this.$emit('confirm');
          this.$emit('close');
          this.actionBeforeLogout?.();
          this.$router.push({
            name: 'logout'
          });
        },
      }})
    }
  }
